import PropTypes from 'prop-types';
import { useCallback } from 'react';
import Drawer, { DrawerHeader } from 'common/components/drawer';

import Header from './Header';
import { DrawerState } from 'common/entities/drawer/DrawerTypes';

import DrawerBody from 'views/enums/purchasing-stores/form/DrawerBody';

const Form = ({ active, drawer, type, refetchData }) => {
  const closeForm = useCallback(() => {
    drawer.close();
  }, [drawer]);

  return (
    <Drawer isOpen={drawer?.isOpen} close={closeForm} size={type === 'equivalent' ? 'lg' : 'sm'}>
      <DrawerHeader>
        <Header type={type} groupName={`${active?.code}. ${active?.description}`} />
      </DrawerHeader>

      <DrawerBody
        type={type}
        drawer={drawer}
        active={active}
        refetchData={refetchData}
        key={type}
      />
    </Drawer>
  );
};

export default Form;

Form.propTypes = {
  type: PropTypes.oneOf('ocean-link', 'create', 'edit', 'link', 'equivalent', 'import'),
  drawer: DrawerState.isRequired,
  active: PropTypes.shape({
    id: PropTypes.number,
    parent_id: PropTypes.number,
    name: PropTypes.string,
    code: PropTypes.string
  }),
  refetchData: PropTypes.func
};
